/**
 * @file 制片人角色判断 hook
 * @description 判断当前用户在当前项目中是否为制片人。
 * 非项目上下文（URL 无 projectId）下返回 true——个人维度用户即操作主体。
 */

import {useUrlProjectId} from './useUrlProjectId';
import {usePermissionsStore} from '@/store/usePermissionsStore';

export const useIsProducer = (): boolean => {
    const projectId = useUrlProjectId();
    const roleCodesByProject = usePermissionsStore((s) => s.roleCodesByProject);

    // 非项目页面：视为操作主体本人，等价于制片人
    if (!projectId) return true;

    // 权限数据尚未加载：fail-open，避免闪烁错误变体
    if (!(projectId in roleCodesByProject)) return true;

    const roleCodes = roleCodesByProject[projectId];
    return roleCodes.includes('producer');
};
